import CRUDCriteriaList from "../../features/CRUD/crudCriteriaList/CRUDCriteriaList";

const CRUDCriteria = () => {
  return <div><CRUDCriteriaList /></div>;
};

export default CRUDCriteria;
